import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { listSellOrderState } from '@/api/dict.js';
import { listStockoutApply, listStockoutApplyDetail } from '@/api/stock.js';
import { findDealerUserManu } from '@/api/manufacturer.js';
import YTable from '@/views/components/table/index.vue';
import dayjs from 'dayjs';
import { listAppType, listAppStatus } from '@/api/dict.js';
export default {
  name: 'order-stockout-apply-index',
  components: {
    YTable: YTable
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (vm.initialized) {
        vm.loadData();
      }
    });
  },
  data: function data() {
    var _this = this;

    return {
      dataList: [],
      // 订单列表
      dataLoading: false,
      initialized: false,
      searchForm: {
        status: null,
        // 状态
        orderNumber: null,
        // 订单编号
        page: 1,
        pageSize: 10,
        total: 0
      },
      timestamp: new Date().valueOf(),
      statusList: listAppStatus(),
      // 状态列表
      searchFormExpand: false,
      // 是否展开搜索表单
      detailList: [],
      // 订单产品列表
      detailLoading: false,
      // 订单产品列表loading
      detailForm: {
        sellOrderId: null,
        page: 1,
        pageSize: 5,
        total: 0
      },
      dataTableCurrentRow: null,
      detailTableCurrentRow: null,
      dataTableCacheName: 'SC-' + this.$route.name + '-data-table',
      detailTableCacheName: 'SC-' + this.$route.name + '-detail-table',
      appTypeList: listAppType(),
      columns: [{
        label: '申请单号',
        prop: 'orderNumber',
        checked: true,
        fixedWidth: true,
        width: 200
      }, {
        label: '申请单类型',
        prop: 'appType',
        checked: true,
        fixedWidth: true,
        width: 100,
        formatter: function formatter(val) {
          var findRow = _this.appTypeList.find(function (item) {
            return item.ID === val;
          });

          if (findRow) {
            return '<a class="el-link el-link--' + findRow.type + '"><span class="el-link--inner">' + findRow.name + '</span></a>';
          } else {
            return val;
          }
        }
      }, {
        label: '经销商',
        prop: 'distributorName',
        checked: true,
        fixedWidth: true,
        width: 200
      }, {
        label: '医院',
        prop: 'hospitalName',
        checked: true,
        fixedWidth: true,
        width: 200
      }, {
        label: '状态',
        prop: 'status',
        checked: true,
        width: 100,
        fixedWidth: true,
        slot: 'status'
      }, {
        label: '申请日期',
        prop: 'CreatedAt',
        checked: true,
        fixedWidth: true,
        width: 150,
        formatter: function formatter(val) {
          return dayjs(val).format('YYYY-MM-DD');
        }
      }, {
        label: '备注',
        prop: 'remarks',
        checked: true,
        width: 200
      }, {
        label: '操作',
        prop: 'operations',
        checked: true,
        width: 100,
        fixedWidth: true,
        fixed: 'right',
        slot: 'operations'
      }],
      detailColumns: [{
        label: '产品编号',
        prop: 'productNumber',
        checked: true,
        width: 150
      }, {
        label: '产品名称',
        prop: 'productName',
        checked: true,
        width: 150
      }, {
        label: '规格型号',
        prop: 'specificationModel',
        checked: true,
        width: 200
      }, {
        label: '单位',
        prop: 'unit',
        checked: true,
        width: 100
      }, {
        label: '数量',
        prop: 'sellQuantity',
        checked: true,
        width: 100
      }, {
        label: '单价',
        prop: 'sellUnitPrice',
        checked: true,
        width: 100,
        formatter: function formatter(val) {
          return Number(val).toFixed(2);
        }
      }, {
        label: '价格',
        prop: 'sellAmount',
        checked: true,
        width: 100,
        formatter: function formatter(val) {
          return Number(val).toFixed(2);
        }
      }, {
        label: '注册/备案证',
        prop: 'registrationNumber',
        checked: true,
        width: 200
      }, {
        label: '厂家',
        prop: 'manufacturer',
        checked: true,
        width: 200
      }, {
        label: '通用名称',
        prop: 'genericName',
        checked: true,
        width: 120,
        fixedWidth: true
      }]
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var that;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                that = _this2;
                that.dataLoading = false;

                if (that.initialized) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return that.loadData();

              case 5:
                that.initialized = true;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    loadData: function loadData() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var that, query;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                that = _this3;
                that.dataList = [];
                that.detailList = [];
                that.dataLoading = true;
                query = JSON.parse(JSON.stringify(that.searchForm));

                if (query.dateRange) {
                  if (query.dateRange[0] && query.dateRange[1]) {
                    query.sellDateStart = query.dateRange[0];
                    query.sellDateEnd = query.dateRange[1];
                  }

                  delete query.dateRange;
                }

                _context2.next = 8;
                return listStockoutApply(query).then(function (res) {
                  that.dataList = res.list;
                  that.searchForm.total = res.total;
                  that.dataTableCurrentRow = that.dataList.length > 0 ? that.dataList[0] : null;

                  if (that.dataTableCurrentRow) {
                    that.$nextTick(function () {
                      that.$refs.dataTableRef.setCurrentRow(that.dataTableCurrentRow, true);
                      that.dataRowClick(that.dataTableCurrentRow);
                    });
                  }
                }).catch(function (e) {});

              case 8:
                that.dataLoading = false;

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    dataExport: function dataExport() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that, form;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = _this4;
                form = JSON.parse(JSON.stringify(that.searchForm));
                form.toExcel = 1;
                _context3.next = 5;
                return listSellOrderExport(form).then(function (res) {
                  var blob = new Blob([res], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
                  }); // type这里表示xlsx类型

                  // type这里表示xlsx类型
                  var downloadElement = document.createElement('a');
                  var href = window.URL.createObjectURL(blob); // 创建下载的链接

                  // 创建下载的链接
                  downloadElement.href = href;
                  downloadElement.download = '采购订单.xlsx'; // 下载后文件名

                  // 下载后文件名
                  document.body.appendChild(downloadElement);
                  downloadElement.click(); // 点击下载

                  // 点击下载
                  document.body.removeChild(downloadElement); // 下载完成移除元素

                  // 下载完成移除元素
                  window.URL.revokeObjectURL(href); // 释放掉blob对象
                }).catch(function () {});

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    searchFormSubmit: function searchFormSubmit() {
      var that = this;
      that.searchForm.page = 1;
      that.searchForm.total = 0;
      that.loadData();
    },
    pageChange: function pageChange(page) {
      var that = this;
      that.searchForm.page = page;
      that.loadData();
    },
    sizeChange: function sizeChange(pageSize) {
      var that = this;
      that.searchForm.pageSize = pageSize;
      that.searchForm.page = 1;
      that.loadData();
    },
    dataRowClick: function dataRowClick(row) {
      var that = this;
      that.dataTableCurrentRow = row;
      that.detailForm.page = 1;
      that.detailForm.total = 0;
      that.detailForm.sellOrderId = row.ID;
      that.loadDetail();
    },
    dataRowDbClick: function dataRowDbClick(row) {
      var that = this;
      that.dataTableCurrentRow = row;
      that.dataEdit(row);
    },
    dataCreate: function dataCreate() {
      var that = this;
      that.$router.push({
        path: '/order/stockout/apply/create'
      });
    },
    dataEdit: function dataEdit(row) {
      var that = this;
      that.$router.push({
        path: '/order/stockout/apply/detail/' + row.ID
      });
    },
    loadDetail: function loadDetail() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that, query;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this5;
                that.detailList = [];
                that.detailLoading = true;
                query = {
                  sellOrderId: that.dataTableCurrentRow.ID,
                  page: 1,
                  pageSize: 9999
                };
                _context4.next = 6;
                return listStockoutApplyDetail(query).then(function (res) {
                  res.list.map(function (row) {
                    that.detailList.push({
                      ID: row.ID,
                      productNumber: row.specs.productNumber,
                      productName: row.main.productName,
                      specificationModel: row.specs.specificationModel,
                      unit: row.specs.unit,
                      sellQuantity: row.sellQuantity,
                      sellUnitPrice: row.sellUnitPrice,
                      sellAmount: row.sellAmount,
                      registrationNumber: row.main.registrationNumber,
                      manufacturer: row.main.manufacturer,
                      genericName: row.specs.genericName
                    });
                  });
                  that.detailForm.total = res.total;

                  if (that.detailTableCurrentRow) {
                    that.$refs.detailTableRef.setCurrentRow(that.detailTableCurrentRow, true);
                  }
                }).catch(function (e) {});

              case 6:
                that.detailLoading = false;

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    detailPageChange: function detailPageChange(page) {
      var that = this;
      that.detailForm.page = page;
    },
    detailSizeChange: function detailSizeChange(pageSize) {
      var that = this;
      that.detailForm.pageSize = pageSize;
      that.detailForm.page = 1;
    },
    detailRowClick: function detailRowClick(row) {
      var that = this;
      that.detailTableCurrentRow = row;
    },
    stateFormatter: function stateFormatter(val) {
      var findRow = this.statusList.find(function (item) {
        return item.ID === val;
      });

      if (findRow) {
        return '<a class="el-link el-link--' + findRow.type + '"><span class="el-link--inner">' + findRow.name + '</span></a>';
      } else {
        return val;
      }
    }
  }
};